<template>
  <div>
    <b-modal
        v-model="showModal"
        id="product-select-modal-form"
        scrollable
        title="Wybierz bank"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer


    >
      <div class="bank-list-container">

        <h2></h2>
        <h5> Wybierz swój bank, aby wygenerować przelew w odpowiednim formacie</h5>
        <BankIconList
            :banks="banks"
            @onSelect="handleBankSelect"
        />
        <div v-if="selectedBank" class="selected-bank">
          Wybrany bank: <b>{{ selectedBank.name }}</b>
        </div>
        <div class="modal-actions">
          <button class="btn btn-info" @click="generateBankWire" :disabled="!selectedBank">
            Generuj
          </button>
          <button class="btn btn-danger" @click="showModal = false">
            Anuluj
          </button>


        </div>


      </div>


    </b-modal>


  </div>

</template>

<script>
import BankIconList from "./BankIconList.vue";

import {BModal} from "bootstrap-vue-next";
import {paymentsHelperMethods} from "./helper/paymentsHelperMethods";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {usePaymentsManagerModule} from "@/state/pinia";

export default {
  name: "BankWireModal",
  components: {
    BModal,
    BankIconList,
  },
  props: {
    banks: {
      type: Array,
      default: () => [],
    },
    paymentDocumentGuid: {
      type: String,
      required: true,
    },
  },
  emits:["onClose"],
  data() {
    return {
      selectedBank: null,
      showModal:true
    };
  },
computed:{
  paymentsModule(){
    return usePaymentsManagerModule();
  },
  simplepharmAuth(){
    return useSimplepharmAuthModule();
  },
  commonModule(){
    return useCommonAppModule();
  },
  lazyloaderModule(){
    return useLazyLoaderModule();
  },
},
  methods: {


    handleBankSelect(bankKey) {
      this.selectedBank = this.banks.find(bank => bank.key === bankKey);
    },

    generateBankWire() {
      if (!this.selectedBank) return;

      this.paymentsModule.httpGenerateBankWireFile({
        bankKey: this.selectedBank.key,
        paymentDocumentGuid: this.paymentDocumentGuid,
      }).then((response) => {

        if (response) {
          // Extract filename from header
          var fileName = paymentsHelperMethods.getResourceFileNameFromHeader(response);
          if(fileName === null){
            fileName = `przelew_${this.selectedBank.key}.txt`; // fallback name
          }

          var octetStreamMime = 'application/octet-stream';
          var contentType = response.headers["content-type"] || octetStreamMime;
          var blob = new Blob([response.data], {type: contentType});
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);

        }


      })


    },
  },
  watch:{
    showModal: {
      handler(newVal) {
        if(newVal === false){
          this.$emit("onClose");
        }
      },
      deep: true,
    },
  },
  created(){
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.bank-list-container{
  background: #e9ecef;
  padding: 16px;
  border-radius: 4px;
}

.selected-bank{
  margin-top: 4px;
}
</style>
